import type { PrinterStatus } from '@maker-toolchest/shared';

interface PrinterStatusBadgeProps {
  status: PrinterStatus;
  className?: string;
}

const statusConfig: Record<
  PrinterStatus,
  { label: string; className: string }
> = {
  IN_SERVICE: {
    label: 'In Service',
    className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
  },
  IN_STORAGE: {
    label: 'In Storage',
    className: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400',
  },
  NEEDS_MAINTENANCE: {
    label: 'Needs Maintenance',
    className: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
  },
  OUT_OF_SERVICE: {
    label: 'Out of Service',
    className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
  },
  DISPOSED: {
    label: 'Disposed',
    className: 'bg-gray-100 text-gray-600 dark:bg-gray-900 dark:text-gray-500',
  },
};

export function PrinterStatusBadge({ status, className = '' }: PrinterStatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
}
